if (!customElements.get("read-more-button")) {
  customElements.define(
    "read-more-button",
    class ReadMoreButton extends HTMLElement {
      constructor() {
        super();
        this.readMoreButton = this.querySelector("button");
        this.parentContainer = this.closest(".product__description");

        this.readMoreButton.addEventListener("click", (event) => {
          this.expandShowMore(event);
        });

        // Trigger expandShowMore when parentContainer has focus-within
        if (this.parentContainer) {
          this.parentContainer.addEventListener("focusin", () => {
            this.expandShowMore();
          });
        }
      }
      expandShowMore(event) {
        // Get the parent container, then find the sibling .read-more-item
        const contentDisplay = this.parentContainer.querySelector(".read-more-item");
        contentDisplay.classList.toggle("partially-hidden");
        this.readMoreButton.textContent = contentDisplay.classList.contains("partially-hidden")
          ? "Lees meer over deze test"
          : "Lees minder";
      }
    },
  );
}
